function clickEvent(selector, ttq_event){
    let element = document.querySelectorAll(selector)
    if(element){
        element.forEach(e => {
            e.addEventListener('click', event => {
                return ttq.track(ttq_event) 
            })
        })
    }
}

$(document).ready(function () {
    let addToCart = clickEvent('.add-to-cart input.button', 'AddToCart')
    let initiateCheckout = clickEvent('.cart-button-checkout', 'InitiateCheckout')
    let hpButton = clickEvent('.snuggs-btn-header', 'ViewContent')
});
